import '../stylesheets/components/footer.scss';

export default function Footer() {
  return (
    <footer>
      <p className="text-center">
        <small>
          © 2022 - This website content is licensed under a&nbsp;
          <a href="https://creativecommons.org/licenses/by/4.0/" rel="license">
            Creative Commons Attribution 4.0 International license
          </a>.
        </small>
      </p>
      <p className="text-center">
        <small>
          See the website&rsquo;s repository at&nbsp;
          <a href="https://gitlab.igem.org/2022/stanford">
            gitlab.igem.org/2022/stanford
          </a>.
        </small>
      </p>
    </footer>
  );
}
